<app-pie-chart *ngIf="segments" [segments]="segments"></app-pie-chart>
